import { NavLink } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

const NavLinks = () => {
  const { user, loading } = useAuth();

  const baseClass =
    "relative uppercase font-semibold tracking-[0.18em] text-xs text-white/85 hover:text-white transition-colors focus:outline-none focus:ring-2 focus:ring-magenta rounded-md px-2 py-2 min-h-[44px] flex items-center";

  const renderLink = (to: string, label: string) => (
    <NavLink
      to={to}
      end={to === "/"}
      role="menuitem"
      className={({ isActive }) =>
        `${baseClass} ${isActive ? "text-white after:content-[''] after:absolute after:left-2 after:right-2 after:-bottom-1 after:h-[2px] after:rounded-full after:bg-[hsl(var(--magenta-glow))]" : ""}`
      }
    >
      {label}
    </NavLink>
  );

  return (
    <>
      {renderLink("/shop", "Shop")}
      {renderLink("/ingredients", "Ingredients")}
      {renderLink("/about", "About")}
      {renderLink("/faq", "FAQ")}
      {renderLink("/referral", "Referral")}
      {!loading &&
        (user
          ? renderLink("/dashboard", "Account")
          : renderLink("/auth", "Sign In"))}
    </>
  );
};

export default NavLinks;
